import { SplitFactory } from '@splitsoftware/splitio';
import Raven from 'raven-js';

export const ABTest = {
    template: `
        <ng-transclude></ng-transclude>
    `,
    transclude: true,
    bindings: {
        getUser: '&',
        authorizationKey: '@'
    },
    controller: class {
        constructor($window) {
            'ngInject';
            this.$window = $window;
        }

        $onInit() {
            this.user = this.initializeUser();
            this.client = this.initializeClient();
        }

        async initializeUser() {
            try {
                return await this.getUser();
            } catch (err) {
                Raven.captureException(err, { level: 'warning' });
            }
        }

        initializeClient() {

            return new Promise(async (resolve, reject) => {
                try {
                    const key = await this.user;
                    const authorizationKey = this.authorizationKey;
                    const factory = SplitFactory({
                        core: { authorizationKey, key }
                    });
                    const client = factory.client();
                    client.on(client.Event.SDK_READY, () => resolve(client));
                    client.on(client.Event.SDK_READY_TIMED_OUT, () => reject(new Error('split SDK timeout')));
                    this.$window.onbeforeunload = () => { client.destroy(); }; //eslint-disable-line
                } catch(err) {
                    reject(err);
                }
            });
        }

        async getTreatment(splitName, attributes) {
            const fail = message => {
                Raven.captureMessage(`getTreatment error: ${message}`, { level: 'warning' });
                return 'default';
            };

            try {
                const client = await this.client;
                if (!client) {
                    return fail('ERROR: A/B testing client unavailable');
                }
                const user = await this.user;
                if (!user) {
                    return fail('ERROR: A/B testing user unavailable');
                }

                const treatment = client.getTreatment(splitName, attributes);
                if (treatment !== 'control') {
                    return treatment;
                }

                return fail('ERROR in receiving treatments');
            } catch (err) {
                return fail(err.message);
            }
        }

        async track(trafficType, eventType, eventValue) {
            try {
                const client = await this.client;
                if (client) {
                    client.track(trafficType, eventType, eventValue);
                }
            } catch (err) {
                Raven.captureException(err, { level: 'warning' });
            }
        }
    }
};
